import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';

import { CookieService } from './cookie.service';
import { ClientPingService } from './client-ping.service';
import { AuthHttpClient } from './auth-http.service';
import { SharedClientService } from '../components/client/shared/services/shared-client.service';

declare var window: any;


export class AuthService {
	public isLoggedIn: boolean = false;
	public isUs: boolean = false;
	public userId: number;
	public userType: string;
	public clientPermissions: any = {
		routes: {
			'/source': {
				permissionToCheck: 'source',
				access: false
			},
			'/source-v3': {
				permissionToCheck: 'source-v3',
				access: false
			},
			'/user': {
				permissionToCheck: '',
				access: true
			},
			'/settings': {
				permissionToCheck: '',
				access: true
			},
			'/notifications': {
				permissionToCheck: '',
				access: true
			},
			'/billing': {
				permissionToCheck: '',
				access: true
			},
			'/interviews': {
				permissionToCheck: '',
				access: true
			},
			'/screen-talent': {
				permissionToCheck: 'external-tests',
				access: false
			},
			'/brand': {
				permissionToCheck: 'branding',
				access: false
			}
		},
		// raw list from server of all permissions
		raw: {},
		hasPermission: (permissionName: string) => {
			let result: boolean = false;
			for (let index in this.clientPermissions.raw) {
				if (this.clientPermissions.raw.hasOwnProperty(index)) {
					let permission = this.clientPermissions.raw[index];
					if (permission['permission'] === permissionName) {
						result = true;
						break;
					}
				}
			}

			return result;
		}
	};

	public userTypeSource = new Subject<string>();
	public userType$ = this.userTypeSource.asObservable();

	public adminId: string | null = null;

	constructor(
		private cookieService: CookieService,
		private clientPingService: ClientPingService,
		private sharedClientService: SharedClientService,
		private sHttp: AuthHttpClient) {
		let cookieApp: any = this.cookieService.get();
		if (cookieApp) {
			this.isLoggedIn = true;

			if (typeof cookieApp['is_us'] !== 'undefined' && cookieApp['is_us'] === true) {
				this.isUs = true;
				this.adminId = cookieApp['admin_id'] || null;
			}
		}
		this.userType = cookieApp.user_type;
		if (typeof cookieApp[this.userType] !== 'undefined') {
			this.userId = cookieApp[this.userType].id;

			// gtag set userId tracking
			if (this.userType === 'client') {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					userId: this.userId
				});

				if (!this.isUs) {
					this.clientPingService.ping(this.userId);
				}
			}
		}

		this.provideAnalytics();
	}

	public setClientPermissions(permissions: any[]) {
		if (!permissions || !permissions.length) {
			// reset all perm
			Object.keys(this.clientPermissions.routes).forEach((route) => {
				this.clientPermissions.routes[route].access = (this.clientPermissions.routes[route].permissionToCheck === '');
			});
			this.clientPermissions.raw = {};
		}

		this.clientPermissions.raw = permissions;

		// set permissions
		Object.keys(this.clientPermissions.routes).forEach((route) => {
			if (this.clientPermissions.routes[route].permissionToCheck === '') {
				// ignor allowed routes
				return;
			}

			// check if permission is in the server ones
			this.clientPermissions.routes[route].access = permissions.some((serverPerm) => serverPerm.permission === this.clientPermissions.routes[route].permissionToCheck);
		});
	}

	public setUserTypeNavigation(type: any) {
		this.userType = type;
		this.userTypeSource.next(type);
	}

	public logout(): void {
		this.cookieService.deleteAppCookie();
		if (this.clientPingService.pingInstance) {
			clearInterval(this.clientPingService.pingInstance);
		}

		if (this.userType === 'client') {
			let url = '/v3/client/auth/client/session';
			this.sHttp.delete(url).subscribe();
		}

		setTimeout(() => window.location.assign(process.env.LANDING_PAGES_URL), 0);
	}

	private coralogixDisabled() {
		return !this.isLoggedIn || !process.env.CORALOGIX_RUM_PUBLIC_API_KEY || !process.env.CORALOGIX_RUM_PUBLIC_DOMAIN || !process.env.APP_NAME || !process.env.APP_RELEASE_VERSION || !window.CoralogixRum;
	}

	private pylonDisabled() {
		return !this.isLoggedIn || !process.env.PYLON_PUBLIC_APP_ID;
	}

	private provideAnalytics() {
		if (this.coralogixDisabled() && this.pylonDisabled()) {
			return;
		}

		// use same req for both
		this.sharedClientService.get(this.userId).subscribe(
			(client) => {
				this.addUserToCoralogixRumContext(client);
				this.initPylon(client);
			}
		);
	}

	private initPylon(client: any) {
		if (this.pylonDisabled() || !(window as any).Pylon) {
			return;
		}

		this.sharedClientService.getPylonIdentityHash()
			.catch(() => {
				return Observable.of({ email_hash: '' });
			})
			.subscribe((resp: any) => {
				const chatSettings: any = {
					app_id: process.env.PYLON_PUBLIC_APP_ID,
					email: client.email,
					name: client.contact_name
				};
				const hash = resp && resp.email_hash;
				if (hash) {
					chatSettings.email_hash = hash;
				}
				window.pylon = { chat_settings: chatSettings };
			});
	}

	private addUserToCoralogixRumContext(client: any) {
		if (this.coralogixDisabled()) {
			return;
		}

		window.CoralogixRum.setUserContext({
			user_id: String(this.userId),
			user_name: client.contact_name,
			user_metadata: {
				user_type: this.userType || 'unknown',
				is_impersonation: this.isUs,
				admin_id: this.adminId
			}
		});
	}
static ctorParameters() { return [ { type: CookieService }, { type: ClientPingService }, { type: SharedClientService }, { type: AuthHttpClient } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/auth.service.ts